import { render, staticRenderFns } from "./TypeControlTable.vue?vue&type=template&id=74c5605a&scoped=true"
import script from "./TypeControlTable.vue?vue&type=script&lang=js"
export * from "./TypeControlTable.vue?vue&type=script&lang=js"
import style0 from "./TypeControlTable.vue?vue&type=style&index=0&id=74c5605a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c5605a",
  null
  
)

export default component.exports